import { render, staticRenderFns } from "./AnswersAndSubmissions.vue?vue&type=template&id=3271a070&scoped=true&"
import script from "./AnswersAndSubmissions.vue?vue&type=script&lang=js&"
export * from "./AnswersAndSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AnswersAndSubmissions.vue?vue&type=style&index=0&id=3271a070&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3271a070",
  null
  
)

export default component.exports